import { all, fork } from 'redux-saga/effects';

import certificateInfoReducer from './certificateInfo/reducer';
import certificateInfoSaga from './certificateInfo/saga';

import contactInfoReducer from './contactInfo/reducer';
import contactInfoSaga from './contactInfo/saga';

import historyReducer from './history/reducer';
import historySaga from './history/saga';

import personalDataReducer from './personalData/reducer';
import personalDataSaga from './personalData/saga';

import personalStatusReducer from './personalStatus/reducer';
import personalStatusSaga from './personalStatus/saga';

import readOnlyReducer from './readOnly/reducer';
import readOnlySaga from './readOnly/saga';
import registrationStatusReducer from './registrationStatus/reducer';

import checkRegistrationStatus from './registrationStatus/saga';

import removeCertificateReducer from './removeCertificate/reducer';
import removeCertificateSaga from './removeCertificate/saga';

import accountsAbroadReducer from './accountsAbroad/reducer';
import accountsAbroadSaga from './accountsAbroad/saga';

import accountsAbroadListFiltersReducer from './accountsAbroadListFilters/reducer';

import pioReducer from './participationInOrganizations/reducer';
import pioSaga from './participationInOrganizations/saga';

import addressDetailed from './profileAddressDetailed/reducer';
import addressDetailedSaga from './profileAddressDetailed/saga';

import taxExemptionsReducer from './taxExemptions/reducer';
import taxExemptionsSaga from './taxExemptions/saga';
import personaDataPageSaga from 'modules/Profile/components/PersonalData/saga';

import bankAccountsSaga from 'modules/Profile/redux/bankAccounts/saga';
import bankAccounts from 'modules/Profile/redux/bankAccounts/reducer';
import profileNotificationsSaga from './profileNotifications/saga';
import notificationsSettings from './profileNotifications/reducer';
import relationsSaga from './relations/saga';
import relationsReducer from './relations/reducer';

import personalStatusQesReducer from './participationInQesOrganization/reducer';
import personalStatusQesSaga from './participationInQesOrganization/saga';

export const profileReducers = {
  contactInfo: contactInfoReducer,
  personalData: personalDataReducer,
  personalStatus: personalStatusReducer,
  participationInQesOrganizations: personalStatusQesReducer,
  participationInOrganizations: pioReducer,
  history: historyReducer,
  readOnly: readOnlyReducer,
  registrationStatus: registrationStatusReducer,
  certificateInfo: certificateInfoReducer,
  removeCertificate: removeCertificateReducer,
  accountsAbroad: accountsAbroadReducer,
  accountsAbroadListFilters: accountsAbroadListFiltersReducer,
  addressDetailed,
  bankAccounts,
  taxExemptions: taxExemptionsReducer,
  notificationsSettings,
  relations: relationsReducer,
};

export function* profileSagas() {
  yield all(
    [
      personalStatusSaga,
      contactInfoSaga,
      personalDataSaga,
      pioSaga,
      historySaga,
      readOnlySaga,
      checkRegistrationStatus,
      certificateInfoSaga,
      removeCertificateSaga,
      accountsAbroadSaga,
      addressDetailedSaga,
      taxExemptionsSaga,
      personaDataPageSaga,
      bankAccountsSaga,
      profileNotificationsSaga,
      personalStatusQesSaga,
      relationsSaga,
    ].map(fork),
  );
}
